import React from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import bosniaFlag from "../../resources/bos.png";
import jamaicaFlag from "../../resources/jam.png";
import malaysiaFlag from "../../resources/mal.png";
import sriLankaFlag from "../../resources/sl.png";
import indonesiaFlag from "../../resources/indo.png";
import indiaFlag from "../../resources/ind.png";
import "./styles.scss";
import { useWorkshops } from "../../../contexts/workshops-context/WorkshopsContext";
import { useState } from "react";
import { Country } from "../../constants/Constant";

interface IProps {
  show: boolean;
  loading?: boolean;
  onHide(): void;
  onConfirm?(): void;
}

interface SetCountry {
  country: Country;
}

const setCountry: SetCountry = {
  country: Country.SRI_LANKA,
};

interface Countries {
  SriLanka: boolean;
  bosnia: boolean;
  jamaica: boolean;
  malaysia: boolean;
  india: boolean;
  indonesia: boolean;
}

const initCountries: Countries = {
  SriLanka: false,
  bosnia: false,
  jamaica: false,
  malaysia: false,
  india: false,
  indonesia: false,

};

const SelectCountry = (props: IProps) => {
  const workshops = useWorkshops();

  const [state, setState] = useState(setCountry);
  const [countryState, setCountryState] = useState(initCountries);

  const buttonSet = (
    <Row className="buttonSet-wrapper p-2">
      <Col xs={6}>
        <div
          className="cancel-button blue"
          onClick={() => {
            props.onHide();
          }}
        >
          Cancel
        </div>
      </Col>
      <Col xs={6}>
        <div
          className="confirm-button green"
          onClick={() => {
            workshops.changeCountry(state.country);
            props.onConfirm ? props.onConfirm() : props.onHide();
          }}
        >
          Confirm
        </div>
      </Col>
    </Row>
  );

  return (
    <div>
      <Modal
        show={props.show}
        size="xl"
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Body
          style={{ padding: "70px", paddingTop: "40px" }}
          className="show-grid"
        >
          <Container>
            <Row className="mb-0 mt-0">
              <Col xs={12} md={8} lg={12}>
                {buttonSet}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col xs={12} md={8} lg={12}>
                <p
                  style={{
                    color: "grey",
                    fontWeight: "bolder",
                    fontSize: "25px",
                  }}
                >
                  Select the country :
                </p>
              </Col>
            </Row>

            <Row className="mb-5" style={{ cursor: "pointer" }}>
              <Col
                className={
                  countryState.SriLanka
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                onClick={() => {
                  setState({ ...state, country: Country.SRI_LANKA });
                  setCountryState({
                    ...countryState,
                    SriLanka: true,
                    bosnia: false,
                    jamaica: false,
                    malaysia: false,
                    india: false,
                    indonesia: false,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={sriLankaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  Sri Lanka
                </p>
              </Col>

              <Col
                className={
                  countryState.jamaica
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                onClick={() => {
                  setState({ ...state, country: Country.JAMAICA });
                  setCountryState({
                    ...countryState,
                    SriLanka: false,
                    bosnia: false,
                    jamaica: true,
                    malaysia: false,
                    india: false,
                    indonesia: false,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={jamaicaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  Jamaica
                </p>
              </Col>

              <Col
                className={
                  countryState.malaysia
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                onClick={() => {
                  setState({ ...state, country: Country.MALAYSIA });
                  setCountryState({
                    ...countryState,
                    SriLanka: false,
                    bosnia: false,
                    jamaica: false,
                    malaysia: true,
                    india: false,
                    indonesia: false,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={malaysiaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  Malaysia
                </p>
              </Col>

              <Col
                className={
                  countryState.bosnia
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                onClick={() => {
                  setState({ ...state, country: Country.BOSNIA });
                  setCountryState({
                    ...countryState,
                    SriLanka: false,
                    bosnia: true,
                    jamaica: false,
                    malaysia: false,
                    india: false,
                    indonesia: false,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={bosniaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  Bosnia
                </p>
              </Col>
              <Col
                className={
                  countryState.india
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                style={{ justifyContent: "left" }}
                onClick={() => {
                  setState({ ...state, country: Country.INDIA });
                  setCountryState({
                    ...countryState,
                    SriLanka: false,
                    bosnia: false,
                    jamaica: false,
                    malaysia: false,
                    indonesia: false,
                    india: true,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={indiaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  India
                </p>
              </Col>
              <Col
                className={
                  countryState.indonesia
                    ? "static-boarder"
                    : "select-country-wrapper"
                }
                style={{ justifyContent: "left" }}
                onClick={() => {
                  setState({ ...state, country: Country.INDONESIA });
                  setCountryState({
                    ...countryState,
                    SriLanka: false,
                    bosnia: false,
                    jamaica: false,
                    malaysia: false,
                    india: false,
                    indonesia: true,
                  });
                }}
                xs={6}
                md={4}
                lg={3}
              >
                <div className="profile-image-wrapper">
                  <img src={indonesiaFlag} alt="" />
                </div>
                <p
                  style={{
                    color: "grey",
                    fontSize: "17px",
                    fontWeight: "bolder",
                  }}
                >
                  Indonesia
                </p>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SelectCountry;
